import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_URL from "../Config";
import axios from "axios";
import video from "./icon/video.svg";
import satellite from "./icon/satellite.svg";
import camera from "./icon/camera.svg";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";

const MySwal = withReactContent(Swal);

const EditLive = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    streamTitle: "",
    uploadType: "pre-recorded",
    videoId: null,
    feedUrl: "",
    signalFormat: "",
    webcamSource: "",
    tags: "",
    thumbnail: null,
    description: "",
    scheduleStart: "",
    scheduleEnd: "",
    status: "DRAFT",
    category:"LIVE",
  });

  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [movieName, setMovieName] = useState("");

  useEffect(() => {
    const fetchStream = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/streams/${id}`);
        const data = res.data;
        setFormData({
          streamTitle: data.streamTitle,
          uploadType: data.uploadType?.toLowerCase() || "pre-recorded",
          videoId: data.videoId || null,
          feedUrl: data.feedUrl || "",
          signalFormat: data.signalFormat || "",
          webcamSource: data.webcamSource || "",
          tags: data.tags || "",
          thumbnail: null,
          description: data.description || "",
          scheduleStart: data.scheduleStart ? dayjs(data.scheduleStart).toDate() : null,
          scheduleEnd: data.scheduleEnd ?dayjs(data.scheduleEnd).toDate() : null,
          status: data.status || "DRAFT",
        });
        setMovieName(data.videoTitle || "");
      } catch (err) {
        console.error("Error fetching stream:", err);
      }
    };

    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/v2/video/getall`);
        const movies = res.data.map((video) => ({
          id: video.id,
          title: video.videoTitle,
        }));
        setOptions(movies);
        setFilteredOptions(movies);
      } catch (err) {
        console.error("Error fetching videos:", err);
      }
    };

    fetchStream();
    fetchVideos();
  }, [id]);

  const types = [
    {
      id: "pre-recorded",
      title: "Pre-Recorded Video",
      desc: "Upload or select a video for streaming",
      icon: <img src={video} alt="Video Icon" style={{ width: "60px", height: "50px" }} />,
      btnText: "MP4,MOV,AVI,MKV",
    },
    {
      id: "satellite",
      title: "Satellite Feed",
      desc: "Connect to satellite sources for live broadcasting",
      icon: <img src={satellite} alt="Satellite Icon" style={{ width: "60px", height: "50px" }} />,
      btnText: "RTMP, HLS, WebRTC",
    },
    {
      id: "websources",
      title: "Webcam Stream",
      desc: "Stream directly from your camera",
      icon: <img src={camera} alt="Camera Icon" style={{ width: "60px", height: "50px" }} />,
      btnText: "Direct Camera Access",
    },
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleInputChange = (e) => {
    const value = e.target.value.toLowerCase();
    const value2 = e.target.value;

    const startsWithValue = options.filter((option) =>
      option.title.toLowerCase().startsWith(value)
    );

    const containsValue = options.filter(
      (option) =>
        option.title.toLowerCase().includes(value) &&
        !option.title.toLowerCase().startsWith(value)
    );

    const filtered = [...startsWithValue, ...containsValue];

    setFilteredOptions(filtered);
    setDropdownOpen(true);
    setMovieName(value2);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("title", formData.streamTitle);
      if (formData.scheduleStart)
            data.append("scheduleStart",  dayjs(formData.scheduleStart).format("YYYY-MM-DDTHH:mm:ssZ")); 
          if (formData.scheduleEnd)
            data.append("scheduleEnd", dayjs(formData.scheduleEnd).format("YYYY-MM-DDTHH:mm:ssZ"));
      data.append("uploadType", formData.uploadType.toUpperCase());
      data.append("status", formData.status);

      if (formData.tags) data.append("tags", formData.tags);
      if (formData.description) data.append("description", formData.description);

      if (formData.uploadType === "pre-recorded") {
        if (formData.videoId) {
          data.append("videoId", formData.videoId);
        }
      }

      if (formData.uploadType === "satellite") {
        data.append("feedUrl", formData.feedUrl);
        data.append("signalFormat", formData.signalFormat);
      }

      if (formData.uploadType === "websources") {
        data.append("webcamSource", formData.webcamSource);
      }

      if (formData.thumbnail) {
        data.append("image", formData.thumbnail);
      }

      await axios.post(`${API_URL}/api/streams/edit/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      MySwal.fire({
        icon: "success",
        title: "Updated!",
        text: "Stream updated successfully 🎉",
      });
      navigate("/admin/LiveStream");
    } catch (err) {
      console.error("Update Error ", err);
      MySwal.fire({
        icon: "error",
        title: "Update Failed",
        text: err.response?.data || "Something went wrong!",
      });
    }
  };

  return (
    <div className="marquee-container">
      <div className="AddArea">
        <button className="btn btn-custom" onClick={() => navigate("/admin/LiveStream")}>
        Stream Management
        </button>
      </div>
      <br />
      <div className="container3">
        <ol className="breadcrumb mb-4 d-flex my-0">
          <li className="breadcrumb-item text-white">Edit Live Stream</li>
        </ol>

        <div className="outer-container">
          <div className="table-container p-4">
            {/* Upload Type Cards */}
            <div className="upload-types mb-4">
              {types.map((type) => (
                <div
                  key={type.id}
                  className={`upload-card ${formData.uploadType === type.id ? "active" : ""}`}
                  onClick={() => setFormData((prev) => ({ ...prev, uploadType: type.id }))}
                >
                  <div className="icon ms-1">{type.icon}</div>
                  <h5>{type.title}</h5>
                  <p>{type.desc}</p>
                  <button id="upload-content-button">{type.btnText}</button>
                </div>
              ))}
            </div>

            {/* Edit Form */}
            <div id="live-stream-form">
              <form onSubmit={handleUpdate}>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Stream Title*</label>
                    <input
                      type="text"
                      name="streamTitle"
                      value={formData.streamTitle}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  {formData.uploadType === "pre-recorded" && (
                    <div className="mb-3" style={{ position: "relative" }}>
                      <label className="form-label">Select Video*</label>
                      <input
                        type="text"
                        value={movieName}
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Search video..."
                      />

                      {dropdownOpen && filteredOptions.length > 0 && (
                        <div
                          className="list-group position-absolute w-100"
                          style={{
                            maxHeight: "120px",
                            overflowY: "auto",
                            zIndex: 1000,
                            background: "white",
                            border: "1px solid #ccc",
                          }}
                        >
                          {filteredOptions.map((option, idx) => (
                            <button
                              type="button"
                              key={idx}
                              className="list-group-item list-group-item-action"
                              onClick={() => {
                                setMovieName(option.title);
                                setFormData((prev) => ({ ...prev, videoId: option.id }));
                                setDropdownOpen(false);
                              }}
                            >
                              {option.title}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {formData.uploadType === "satellite" && (
                    <>
                      <div className="mb-3">
                        <label className="form-label">Feed URL*</label>
                        <input
                          type="text"
                          name="feedUrl"
                          value={formData.feedUrl}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="http://satellitefeed.example.com"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Signal Format*</label>
                        <select
                          name="signalFormat"
                          value={formData.signalFormat}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="">Select format</option>
                          <option value="RTMP">RTMP</option>
                          <option value="HLS">HLS</option>
                          <option value="WebRTC">WebRTC</option>
                        </select>
                      </div>
                    </>
                  )}

                  {formData.uploadType === "websources" && (
                    <div className="mb-3">
                      <label className="form-label">Webcam Source*</label>
                      <select
                        name="webcamSource"
                        value={formData.webcamSource}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="">Select webcam</option>
                        <option value="frontCam">Front Camera</option>
                        <option value="backCam">Back Camera</option>
                        <option value="virtualCam">Virtual Camera</option>
                      </select>
                    </div>
                  )}

                  <div className="mb-3">
                      <label className="form-label">Category*</label>
                      <input
                        type="text"
                        name="category"
                        value="LIVE"
                        className="form-control"
                        disabled
                      />
                    </div>

                  <div className="mb-3">
                    <label className="form-label">Tags*</label>
                    <input
                      type="text"
                      name="tags"
                      value={formData.tags}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="tech,demo,product"
                    />
                  </div>

                  {/* <div className="mb-3">
                    <label className="form-label">Thumbnail*</label>
                    <input
                      type="file"
                      name="thumbnail"
                      accept="image/*"
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div> */}
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      className="form-control"
                      rows="5"
                      placeholder="Describe your stream..."
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Schedule Start Time*</label><br/>
                    {/* <DatePicker
                      selected={formData.scheduleStart}
                      onChange={(date) =>
                        setFormData((prev) => ({ ...prev, scheduleStart: date }))
                      }
                      placeholderText="Select start time"
                      showTimeSelect
                      dateFormat="Pp"
                      customInput={<input type="text" className="form-control" />}
                    /> */}
                    <input
                        type="datetime-local"
                        className="form-control"
                        value={formData.scheduleStart}
                        onChange={(e) =>
                          setFormData((prev) => ({ ...prev, scheduleStart: e.target.value }))
                        }
                      />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Schedule End Time*</label><br/>
                    {/* <DatePicker
                      selected={formData.scheduleEnd}
                      onChange={(date) =>
                        setFormData((prev) => ({ ...prev, scheduleEnd: date }))
                      }
                      placeholderText="Select end time"
                      showTimeSelect
                      dateFormat="Pp"
                      customInput={<input type="text" className="form-control" />}
                    /> */}
                    <input
                        type="datetime-local"
                        className="form-control"
                        value={formData.scheduleEnd}
                        onChange={(e) =>
                          setFormData((prev) => ({ ...prev, scheduleEnd: e.target.value }))
                        }
                      />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Thumbnail*</label>
                    <input
                      type="file"
                      name="thumbnail"
                      accept="image/*"
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="text-end mt-4">
                <button
                  type="button"
                  className="btn btn-secondary m-4"
                  onClick={() => navigate("/admin/LiveStream")}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-custom me-4">
                  Update Stream
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditLive;